import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../StaffCard.css";

class Profile extends Component {
  render() {
    const { classes, staff } = this.props;
    return (
      <div className={classes.navRoot}>
        <div className={classes.navContent}>
          <h3>General</h3>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Contract Type</div>
            <div>{staff.contractType}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Department</div>
            <div>{staff.department}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Designation</div>
            <div>{staff.designation}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Date of Joining(AD)</div>
            <div>{staff.joinedDate}</div>
          </ListItem>
          <ListItem divider>
            <div style={{ flexGrow: 1 }}>Date of Joining(BS)</div>
            <div>{staff.joinedDate}</div>
          </ListItem>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Profile);
